<template>
  <div class="page">
  
    <div class="banner">
      <img :src="banner" mode="widthFix" alt="">
      <h3>数字工业自动化<br/>高级工程师</h3>
      <p>PLC方向</p>
    </div>
    <ul>
      <li v-for="(item, index) in model" :key="index" @click="checkLogin(index)">
        <img :src="item.icon" mode="widthFix" lazy-load="false" />
        <p>{{ item.name }}</p>
        <span v-if="item.auditStatusText">{{ item.auditStatusText }}</span>
      </li>
    </ul>
    <img class="page-bg" src="https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/Activity/AutoEng/a.png" alt="">
    <div class="confirm-btn" v-if="authInfo.PayStatus">已报名</div>
    <div class="confirm-btn" v-else @click="submit">立即报考 {{ count ? '￥'+count : '' }}</div>
    <login ref="loginRef" @success="init"/>
    <van-dialog v-model="isShowQrcode" :title="`微信扫码支付￥${count}`" @confirm="clearWeiXin">
      <div class="qrcode-wrapper">
        <img class="qrcode" id="qrcode" :src="qrcode" alt="">
      </div>
    </van-dialog>


  </div>
</template>

<script>
import {autoExamEngineerCreateOrder,GetUserAuthInfo, WeiXinPay, Impower2, PcWeiXinPay, WeiXinQueryOrder} from '@/common/api.js'
import wx from 'weixin-js-sdk'
import login from './template/login.vue';
import QRCode from 'qrcode';

export default {
  components: { login },
  data(){
    return {
      banner: 'https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/Activity/AutoEng/f.png',
      model: [
          {
              name: '证书介绍',
              icon: 'https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/Activity/AutoEng/b.png',
              disabled: false,
              link: '/engineerRExam/webview?modelIndex=1'
          },
          {
              name: '考试流程',
              icon: 'https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/Activity/AutoEng/e.png',
              disabled: true,
              link: '/engineerRExam/webview?modelIndex=2'
          },
          {
              name: '24年题库真题模拟',
              icon: 'https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/Activity/AutoEng/c.png',
              disabled: true,
              link: '/engineerRExam/exam'
          },
          {
              name: '上传资质资料',
              icon: 'https://gk-manager.oss-cn-zhangjiakou.aliyuncs.com/Activity/AutoEng/d.png',
              disabled: true,
              link: '/engineerRExam/apply',
              auditStatusText: ''
          },
      ],
      applyMode: {
          name: '立即报名',
          price: 1000,
          disabled: false
      },
      engineerRExamUserInfo: JSON.parse(this.$getStorage('engineerRExamUserInfo')),
      // 弹框二维码支付
      isShowQrcode: false,
      count: 0,
      time: null,
      qrcode: '',
      authInfo: {}
    }
  },
  mounted() {
    var imgUrl="https://oss.insupai.com/bpofolder/20240725/202407251744311886.png?x-oss-process=style/bpostyle";
    var index=imgUrl.indexOf('?');
    if(index>=0)
    {
      imgUrl=imgUrl.substring(0,index);
    }
    console.log("url:"+imgUrl)
    this.init()
  },
  methods: {
    init() {
      this.engineerRExamUserInfo = JSON.parse(this.$getStorage('engineerRExamUserInfo'));
      if(this.$getStorage('engineerRExamUserId')){
        this.getUserAuthInfoFn();
      }
    },
    checkLogin(index) {
      if(!this.engineerRExamUserInfo && index) {
        this.$toast('请先登录后再操作')
        setTimeout(() => {
          this.$refs.loginRef.onShow();
        }, 2000);
      }else {
        if(this.model[index].disabled) {
          this.$toast('请报名后再操作')
        }else {
          this.$router.push(this.model[index].link)
        }
      }
    },
    submit() {
      if(!this.engineerRExamUserInfo) {
        this.$toast('请先登录后再操作')
        setTimeout(() => {
          this.$refs.loginRef.onShow();
        }, 2000);
        return ;
      }
      let params = {
        UserId: this.engineerRExamUserInfo.UserId,
        Handset: this.engineerRExamUserInfo.Handset,
        appKey: '1',
        Sign: '1',
        platform: 'mweb'
      }
      console.log("params",params);
      autoExamEngineerCreateOrder(params).then(r=>{
          if (r.Result == 1) {
            let ua = window.navigator.userAgent.toLowerCase();
            let isPhone = /mobile/i.test(ua);
            let isWeiXin = ua.match(/MicroMessenger/i) == 'micromessenger';
              if(isPhone) {
                if(isWeiXin){ // 是来自微信内置浏览器
                  this.wxpay(r.Data.PayId);
                }else {
                  this.openWebUrlpay(r.Data.PayId)
                }
              }else {
                this.pcWxpay(r.Data.PayId)
              }
          }else {
              this.$toast(r.Message);
          }
      });
    },
    openWebUrlpay(payId){
      let params = {
        "payId": payId, //--支付单Id
        "applicationType":7,// --写死
        "accountId": this.engineerRExamUserInfo.UserId, 
        "accountType":1,
        "openId":"",
        "platform":"mweb"
      }
      WeiXinPay(params).then(r=>{
        if(r.Result==1){
          let data=r.Data;
          // 3.跳转微信支付中间页
          window.location.replace(data.MWebUrl);
        }else{
          this.$toast(r.Message);
        }
      })
    },
    wxpay(payId) {
      let openId = this.$route.query.wxOfficialAccountOpenId;
      let params = {
        "payId": payId, //--支付单Id
        "applicationType":5,// --写死
        "accountId": this.engineerRExamUserInfo.UserId, 
        "accountType":1,
        "openId": openId,
        "platform":"mweb"
      }
      if(!openId){
        Impower2(window.location.href,2,"p" + this.engineerRExamUserInfo.UserId);
        return;
      }
      let that=this;
      WeiXinPay(params).then(r=>{
        if(r.Result==1){
          let data=r.Data;
          wx.config({
            debug: false,
            appId: data.AppId,
            timestamp: data.Timestamp,
            nonceStr: data.NonceStr,
            signature: data.WxPaySign,
            jsApiList: ['chooseWXPay']
          })
          let config={
            timestamp: data.Timestamp,
            nonceStr:data.NonceStr,
            package:`prepay_id=${data.Prepay_Id}`,
            paySign:data.WxPaySign,
            signType:'MD5',
            success(res) {
              that.init();
            },
          }
          wx.ready(()=>{
            wx.chooseWXPay(config)
          })
        }else{
          this.$toast(r.Message);
        }
      })
    },
    pcWxpay(payId) {
      let params = {
        "payId": payId, //--支付单Id
        "userCode": "p" + this.engineerRExamUserInfo.UserId, 
        "platform":"mweb"
      }
      let that = this
      PcWeiXinPay(params).then(r=>{
        if(r.Result == 1){
          this.isShowQrcode=true;
          this.count = r.Data.PayMoney
          this.getQrcode(r.Data.QrCodeUrl);
          that.time = setInterval(() => {
          //定时刷新订单状态
            this.payment(r.Data.GkAlipayId);
          }, 1000);
        }else {
          this.$toast(r.Message);
        }
      })
    },
    //生成二维码
    getQrcode(url){
      let opts = {
        errorCorrectionLevel: "H",//容错级别
        type: "image/png",//生成的二维码类型
        quality: 0.3,//二维码质量
        margin: 0,//二维码留白边距
        text: url,//二维码内容
        color: {
          dark: "#333333",//前景色
          light: "#fff"//背景色
        }
      };
      let that = this;
      QRCode.toDataURL(url, opts, function (err, url) {
        if (err) throw err
        that.qrcode=url;
      })
    },
    // 轮询pc扫微信二维码支付是否成功
    payment(gkId){
      let data = {}
      data.gkAlipayId = gkId
      WeiXinQueryOrder(data).then(res=> {
        if(res.Data.IsPaySuccess) {
          this.clearWeiXin()
          this.$toast("支付成功");
          this.init();
        }
      })
    },
    // 关闭微信支付
    clearWeiXin(){
      this.isShowQrcode = false
      clearInterval(this.time)
    },
    getUserAuthInfoFn() {
      let params = {
        UserId: this.engineerRExamUserInfo.UserId,
        Handset: this.engineerRExamUserInfo.Handset,
        appKey: '1',
        Sign: '1',
        platform: 'H5'
      }
      GetUserAuthInfo(params).then(r=>{
        if(r.Result == 1) {
          this.model[1].disabled =  !r.Data.PayStatus;
          this.model[2].disabled =  !r.Data.PayStatus;
          this.model[3].disabled =  !r.Data.PayStatus;
          this.count = r.Data.AutoEngineerApplyPayAmount;
          this.model[3].auditStatusText = {
            1: '待审核',
            2: '审核成功',
            3: '审核失败'
          }[r.Data.AuditStatus];
          this.authInfo = r.Data;
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.page {
  padding: 40px 15px;
  background: #eaecf5;
  min-height: 100vh;
  .banner {
    color: #fff;
    width: 100%;
    position: relative;
    img {
      width: 100%;
      height: 100%;
    }
    h3 {
      position: absolute;
      top: 15px;
      padding-left: 15px;
      line-height: 1.5;
      font-size: 17px;
      font-weight: 300;
    }
    p {
      position: absolute;
      padding-left: 15px;
      bottom: 15px;
      font-size: 14px;
      font-weight: 200;
    }
  }
  ul {
    margin: 0.5rem 0 0px 0;
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-gap: 15px;
    li {
      width: 100%;
      background: #fff;
      border-radius: 15px;
      padding-bottom: 10px;
      position: relative;
      cursor: pointer;
      img {
        width: 55px;
        display: block;
        margin: 0.5rem auto;
      }
      p {
        font-size: 14px;
        color: #666;
        text-align: center;
      }
      span {
        position: absolute;
        right: 0;
        top: 0;
        font-size: 13px;
        color: #fff;
        padding: 3px 5px;
        background: #f33b3d;
        border-radius: 5px 5px 0 5px;
      }
    }
  }
  .page-bg {
    width: 100%;
    margin-top: -40px;
  }
  .confirm-btn {
    height: 45px;
    background: #5c82fe;
    border-radius: 10px;
    text-align: center;
    line-height: 45px;
    color: #fff;
    margin: 0px auto;
  }
  .qrcode-wrapper{
    padding: 20px;
    .name{
      font-size: 20px;
      color: #999;
      margin-bottom: 10px;
    }
    .price{
      font-size: 20px;
      color: #f75959;
      font-weight: bold;
    }
    .qrcode{
      display: block;
      width: 200px;
      height: 200px;
      margin: 0px auto 10px;
    }
    .tips{
      font-size: 12px;
      color: #999;
      line-height: 22px;
    }
  }
}
</style>